<template>
  <b-modal
      v-model="showModal"
      has-modal-card
      trap-focus
      :destroy-on-hide="false"
      aria-role="dialog"
      aria-label="Nieprawidłowa sesja"
      aria-modal
      :can-cancel="false">
    <template>
      <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
          <p class="modal-card-title">Nieprawidłowa sesja</p>
        </header>
        <section class="modal-card-body">
          <p>Sesja wygasła! Zaloguj się ponownie</p>
        </section>
        <footer class="modal-card-foot">
          <b-button
              type="is-danger"
              label="Zaloguj się"
              @click="$router.go('callback')" />
        </footer>
      </div>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: "LoginModal",
  props: {
    showModal: Boolean
  }
}
</script>

<style scoped>

</style>
